export default __webpack_public_path__ + "static/media/search_girl.d8567cce.svg";